import React from "react";
import Camera, { FACING_MODES } from "react-html5-camera-photo";
import PropTypes from "prop-types";
import "react-html5-camera-photo/build/css/index.css";

const propTypes = {
  setAttachment: PropTypes.func.isRequired,
};

export default function CameraComponent(props) {
  function handleTakePhoto(dataUri) {
    let file = new File([dataUri], "image.jpg", { type: "image/jpg", lastModified: Date.now });
    props.setAttachment(file);
    return dataUri;
  }

  return (
    <Camera
      idealFacingMode={FACING_MODES.ENVIRONMENT}
      onTakePhoto={(dataUri) => {
        handleTakePhoto(dataUri);
      }}
    />
  );
}
